import * as React from "react";

import * as moment from "moment-timezone";

interface IProps {
  value: string;
  onChange: (value: string) => any;
}

interface IZoneName {
  name: string;
  value: string;
}

export class TimeZonePicker extends React.Component<IProps> {
  public render() {
    const { value } = this.props;
    return (
      <select
        value={value}
        onChange={this.onChange}
        className="form-control form-control-sm"
        id="inputTimezone"
      >
        onChange
        {TZ_NAMES.map(this.renderZoneOption)}
      </select>
    );
  }

  private renderZoneOption = (tz: IZoneName) => (
    <option key={tz.value} value={tz.value}>
      {tz.name} - {moment.tz(tz.value).format("HH:mm")} now
    </option>
  );

  private onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { selectedOptions } = e.currentTarget;
    if (selectedOptions.length === 0) {
      return;
    }

    const selectedTZ = selectedOptions[0].value;
    this.props.onChange(selectedTZ);
  };
}

const TZ_NAMES: IZoneName[] = [
  { value: "Pacific/Midway", name: "Midway" },
  { value: "Pacific/Samoa", name: "Samoa" },
  { value: "Pacific/Pago_Pago", name: "Pago Pago" },
  { value: "Pacific/Niue", name: "Niue" },
  { value: "Pacific/Tahiti", name: "Tahiti" },
  { value: "Pacific/Rarotonga", name: "Rarotonga" },
  { value: "Pacific/Honolulu", name: "Honolulu (Hawaii)" },
  { value: "Pacific/Johnston", name: "Johnston" },
  { value: "Pacific/Marquesas", name: "Marquesas" },
  { value: "Pacific/Gambier", name: "Gambier" },
  { value: "America/Atka", name: "Atka" },
  { value: "America/Adak", name: "Adak" },
  { value: "Pacific/Pitcairn", name: "Pitcairn" },
  { value: "America/Yakutat", name: "Yakutat" },
  { value: "America/Nome", name: "Nome" },
  { value: "America/Juneau", name: "Juneau" },
  { value: "America/Anchorage", name: "Anchorage (Alaska)" },
  { value: "America/Dawson", name: "Dawson" },
  { value: "America/Santa_Isabel", name: "Santa Isabel" },
  { value: "America/Phoenix", name: "Phoenix (MST)" },
  { value: "America/Ensenada", name: "Ensenada" },
  { value: "America/Tijuana", name: "Tijuana" },
  { value: "America/Los_Angeles", name: "Los Angeles (Pacific)" },
  { value: "America/Dawson_Creek", name: "Dawson Creek" },
  { value: "America/Whitehorse", name: "Whitehorse" },
  { value: "America/Hermosillo", name: "Hermosillo" },
  { value: "America/Vancouver", name: "Vancouver" },
  { value: "America/Managua", name: "Managua" },
  { value: "America/Cambridge_Bay", name: "Cambridge Bay" },
  { value: "America/Regina", name: "Regina" },
  { value: "America/Shiprock", name: "Shiprock" },
  { value: "America/Tegucigalpa", name: "Tegucigalpa" },
  { value: "Pacific/Galapagos", name: "Galapagos" },
  { value: "America/Denver", name: "Denver (Mountain)" },
  { value: "America/Inuvik", name: "Inuvik" },
  { value: "America/Edmonton", name: "Edmonton" },
  { value: "America/Yellowknife", name: "Yellowknife" },
  { value: "America/Swift_Current", name: "Swift Current" },
  { value: "America/Chihuahua", name: "Chihuahua" },
  { value: "Pacific/Easter", name: "Easter" },
  { value: "America/Belize", name: "Belize" },
  { value: "America/Boise", name: "Boise" },
  { value: "America/Costa_Rica", name: "Costa Rica" },
  { value: "America/Mazatlan", name: "Mazatlan" },
  { value: "America/Ojinaga", name: "Ojinaga" },
  { value: "America/El_Salvador", name: "El Salvador" },
  { value: "America/Guatemala", name: "Guatemala" },
  { value: "America/Chicago", name: "Chicago (Central)" },
  { value: "America/Mexico_City", name: "Mexico City" },
  { value: "America/Rio_Branco", name: "Rio Branco" },
  { value: "America/Cancun", name: "Cancun" },
  { value: "America/Resolute", name: "Resolute" },
  { value: "America/Jamaica", name: "Jamaica" },
  { value: "America/Porto_Acre", name: "Porto Acre" },
  { value: "America/Bogota", name: "Bogota" },
  { value: "America/Panama", name: "Panama" },
  { value: "America/Indiana/Tell_City", name: "Indiana - Tell City" },
  { value: "America/North_Dakota/New_Salem", name: "North Dakota - New Salem" },
  { value: "America/Indiana/Knox", name: "Indiana - Knox" },
  { value: "America/North_Dakota/Center", name: "North Dakota - Center" },
  { value: "America/Cayman", name: "Cayman" },
  { value: "America/Atikokan", name: "Atikokan" },
  { value: "America/Rankin_Inlet", name: "Rankin Inlet" },
  { value: "America/Rainy_River", name: "Rainy River" },
  { value: "America/Guayaquil", name: "Guayaquil" },
  { value: "America/Monterrey", name: "Monterrey" },
  { value: "America/Matamoros", name: "Matamoros" },
  { value: "America/Menominee", name: "Menominee" },
  { value: "America/Merida", name: "Merida" },
  { value: "America/Winnipeg", name: "Winnipeg" },
  { value: "America/Knox_IN", name: "Knox IN" },
  { value: "America/Eirunepe", name: "Eirunepe" },
  { value: "America/Coral_Harbour", name: "Coral Harbour" },
  { value: "America/Lima", name: "Lima" },
  { value: "America/Indiana/Winamac", name: "Indiana - Winamac" },
  { value: "America/Indiana/Vincennes", name: "Indiana - Vincennes" },
  { value: "America/Santo_Domingo", name: "Santo Domingo" },
  { value: "America/Santiago", name: "Santiago" },
  { value: "America/Indiana/Vevay", name: "Indiana - Vevay" },
  { value: "America/Montreal", name: "Montreal" },
  { value: "America/Montserrat", name: "Montserrat" },
  { value: "America/Barbados", name: "Barbados" },
  { value: "America/Indiana/Petersburg", name: "Indiana - Petersburg" },
  { value: "America/Virgin", name: "Virgin" },
  { value: "America/Cuiaba", name: "Cuiaba" },
  { value: "America/Curacao", name: "Curacao" },
  { value: "America/Nassau", name: "Nassau" },
  { value: "America/Indiana/Marengo", name: "Indiana - Marengo" },
  { value: "America/New_York", name: "New York (Eastern)" },
  { value: "America/Louisville", name: "Louisville" },
  { value: "America/Indiana/Indianapolis", name: "Indiana - Indianapolis" },
  { value: "America/Port_of_Spain", name: "Port of Spain" },
  { value: "America/Kentucky/Monticello", name: "Kentucky - Monticello" },
  { value: "America/Toronto", name: "Toronto" },
  { value: "America/Aruba", name: "Aruba" },
  { value: "America/Detroit", name: "Detroit" },
  { value: "America/Blanc-Sablon", name: "Blanc-Sablon" },
  { value: "America/Boa_Vista", name: "Boa Vista" },
  { value: "America/Nipigon", name: "Nipigon" },
  { value: "America/Dominica", name: "Dominica" },
  { value: "America/Port-au-Prince", name: "Port-au-Prince" },
  { value: "America/Thunder_Bay", name: "Thunder Bay" },
  { value: "America/Pangnirtung", name: "Pangnirtung" },
  { value: "America/St_Barthelemy", name: "St Barthelemy" },
  { value: "America/Kentucky/Louisville", name: "Kentucky - Louisville" },
  { value: "America/Martinique", name: "Martinique" },
  { value: "America/Asuncion", name: "Asuncion" },
  { value: "America/Campo_Grande", name: "Campo Grande" },
  { value: "America/Anguilla", name: "Anguilla" },
  { value: "America/Marigot", name: "Marigot" },
  { value: "America/Tortola", name: "Tortola" },
  { value: "America/Antigua", name: "Antigua" },
  { value: "America/St_Kitts", name: "St Kitts" },
  { value: "America/La_Paz", name: "La Paz" },
  { value: "America/Havana", name: "Havana" },
  { value: "America/Puerto_Rico", name: "Puerto Rico (Atlantic)" },
  { value: "America/Fort_Wayne", name: "Fort Wayne" },
  { value: "America/Guyana", name: "Guyana" },
  { value: "America/St_Vincent", name: "St Vincent" },
  { value: "America/Iqaluit", name: "Iqaluit" },
  { value: "America/Manaus", name: "Manaus" },
  { value: "America/St_Thomas", name: "St Thomas" },
  { value: "America/Indianapolis", name: "Indianapolis" },
  { value: "America/Guadeloupe", name: "Guadeloupe" },
  { value: "America/St_Lucia", name: "St Lucia" },
  { value: "America/Grand_Turk", name: "Grand Turk" },
  { value: "America/Grenada", name: "Grenada" },
  { value: "America/Caracas", name: "Caracas" },
  { value: "America/Porto_Velho", name: "Porto Velho" },
  { value: "America/Belem", name: "Belem" },
  { value: "America/Mendoza", name: "Mendoza" },
  { value: "America/Moncton", name: "Moncton" },
  { value: "America/Fortaleza", name: "Fortaleza" },
  { value: "America/Halifax", name: "Halifax" },
  { value: "America/Araguaina", name: "Araguaina" },
  { value: "America/Argentina/Buenos_Aires", name: "Argentina - Buenos Aires" },
  { value: "America/Argentina/Catamarca", name: "Argentina - Catamarca" },
  { value: "America/Recife", name: "Recife" },
  {
    value: "America/Argentina/ComodRivadavia",
    name: "Argentina - ComodRivadavia",
  },
  { value: "America/Argentina/Cordoba", name: "Argentina - Cordoba" },
  { value: "America/Montevideo", name: "Montevideo" },
  { value: "America/Rosario", name: "Rosario" },
  { value: "Antarctica/Rothera", name: "Rothera" },
  { value: "America/Argentina/Jujuy", name: "Argentina - Jujuy" },
  { value: "America/Argentina/La_Rioja", name: "Argentina - La Rioja" },
  { value: "America/Cordoba", name: "Cordoba" },
  { value: "America/Argentina/Mendoza", name: "Argentina - Mendoza" },
  { value: "America/Santarem", name: "Santarem" },
  { value: "America/Sao_Paulo", name: "Sao Paulo" },
  { value: "America/Argentina/Rio_Gallegos", name: "Argentina - Rio Gallegos" },
  { value: "America/Argentina/Salta", name: "Argentina - Salta" },
  { value: "America/Cayenne", name: "Cayenne" },
  { value: "America/Catamarca", name: "Catamarca" },
  { value: "America/Argentina/San_Juan", name: "Argentina - San Juan" },
  { value: "America/Maceio", name: "Maceio" },
  { value: "America/Argentina/San_Luis", name: "Argentina - San Luis" },
  { value: "America/Argentina/Tucuman", name: "Argentina - Tucuman" },
  { value: "America/Argentina/Ushuaia", name: "Argentina - Ushuaia" },
  { value: "America/Paramaribo", name: "Paramaribo" },
  { value: "America/Buenos_Aires", name: "Buenos Aires" },
  { value: "America/Jujuy", name: "Jujuy" },
  { value: "America/Thule", name: "Thule" },
  { value: "Atlantic/Stanley", name: "Stanley" },
  { value: "America/Bahia", name: "Bahia" },
  { value: "Antarctica/Palmer", name: "Palmer" },
  { value: "Atlantic/Bermuda", name: "Bermuda" },
  { value: "America/Goose_Bay", name: "Goose Bay" },
  { value: "America/Glace_Bay", name: "Glace Bay" },
  { value: "America/St_Johns", name: "St Johns" },
  { value: "America/Godthab", name: "Godthab" },
  { value: "Atlantic/South_Georgia", name: "South Georgia" },
  { value: "America/Miquelon", name: "Miquelon" },
  { value: "America/Noronha", name: "Noronha" },
  { value: "Atlantic/Cape_Verde", name: "Cape Verde" },
  { value: "Africa/Banjul", name: "Banjul" },
  { value: "UTC", name: "UTC" },
  { value: "Africa/Nouakchott", name: "Nouakchott" },
  { value: "Africa/Bamako", name: "Bamako" },
  { value: "Africa/Bissau", name: "Bissau" },
  { value: "Africa/Abidjan", name: "Abidjan" },
  { value: "Atlantic/Azores", name: "Azores" },
  { value: "Africa/Timbuktu", name: "Timbuktu" },
  { value: "Africa/Monrovia", name: "Monrovia" },
  { value: "Atlantic/Reykjavik", name: "Reykjavik" },
  { value: "America/Danmarkshavn", name: "Danmarkshavn" },
  { value: "Africa/Lome", name: "Lome" },
  { value: "Africa/Dakar", name: "Dakar" },
  { value: "Africa/Freetown", name: "Freetown" },
  { value: "Africa/Conakry", name: "Conakry" },
  { value: "America/Scoresbysund", name: "Scoresbysund" },
  { value: "Africa/Accra", name: "Accra" },
  { value: "Africa/Ouagadougou", name: "Ouagadougou" },
  { value: "Atlantic/St_Helena", name: "St Helena" },
  { value: "Atlantic/Faeroe", name: "Faeroe" },
  { value: "Africa/Niamey", name: "Niamey" },
  { value: "Atlantic/Madeira", name: "Madeira" },
  { value: "Europe/Isle_of_Man", name: "Isle of Man" },
  { value: "Atlantic/Canary", name: "Canary" },
  { value: "Africa/Sao_Tome", name: "Sao Tome" },
  { value: "Africa/Malabo", name: "Malabo" },
  { value: "Europe/Jersey", name: "Jersey" },
  { value: "Europe/London", name: "London" },
  { value: "Europe/Lisbon", name: "Lisbon" },
  { value: "Africa/Brazzaville", name: "Brazzaville" },
  { value: "Africa/Luanda", name: "Luanda" },
  { value: "Africa/Douala", name: "Douala" },
  { value: "Europe/Dublin", name: "Dublin" },
  { value: "Atlantic/Faroe", name: "Faroe" },
  { value: "Africa/Porto-Novo", name: "Porto-Novo" },
  { value: "Africa/Libreville", name: "Libreville" },
  { value: "Europe/Guernsey", name: "Guernsey" },
  { value: "Africa/Lagos", name: "Lagos" },
  { value: "Africa/Bangui", name: "Bangui" },
  { value: "Africa/Kinshasa", name: "Kinshasa" },
  { value: "Africa/Algiers", name: "Algiers" },
  { value: "Africa/Tunis", name: "Tunis" },
  { value: "Europe/Belfast", name: "Belfast" },
  { value: "Africa/El_Aaiun", name: "El Aaiun" },
  { value: "Africa/Casablanca", name: "Casablanca" },
  { value: "Africa/Ndjamena", name: "Ndjamena" },
  { value: "Europe/Vaduz", name: "Vaduz" },
  { value: "Europe/Podgorica", name: "Podgorica" },
  { value: "Europe/Brussels", name: "Brussels" },
  { value: "Africa/Ceuta", name: "Ceuta" },
  { value: "Europe/Andorra", name: "Andorra" },
  { value: "Europe/Ljubljana", name: "Ljubljana" },
  { value: "Atlantic/Jan_Mayen", name: "Jan Mayen" },
  { value: "Europe/Paris", name: "Paris" },
  { value: "Arctic/Longyearbyen", name: "Longyearbyen" },
  { value: "Europe/Budapest", name: "Budapest" },
  { value: "Europe/Zurich", name: "Zurich" },
  { value: "Africa/Johannesburg", name: "Johannesburg" },
  { value: "Africa/Harare", name: "Harare" },
  { value: "Africa/Lubumbashi", name: "Lubumbashi" },
  { value: "Africa/Lusaka", name: "Lusaka" },
  { value: "Europe/Luxembourg", name: "Luxembourg" },
  { value: "Africa/Bujumbura", name: "Bujumbura" },
  { value: "Europe/Rome", name: "Rome" },
  { value: "Europe/Sarajevo", name: "Sarajevo" },
  { value: "Europe/Kaliningrad", name: "Kaliningrad" },
  { value: "Africa/Windhoek", name: "Windhoek" },
  { value: "Europe/Madrid", name: "Madrid" },
  { value: "Africa/Cairo", name: "Cairo" },
  { value: "Europe/Skopje", name: "Skopje" },
  { value: "Europe/Amsterdam", name: "Amsterdam" },
  { value: "Europe/Stockholm", name: "Stockholm" },
  { value: "Europe/Oslo", name: "Oslo" },
  { value: "Europe/Malta", name: "Malta" },
  { value: "Africa/Blantyre", name: "Blantyre" },
  { value: "Africa/Gaborone", name: "Gaborone" },
  { value: "Europe/Tirane", name: "Tirane" },
  { value: "Africa/Maputo", name: "Maputo" },
  { value: "Africa/Khartoum", name: "Khartoum" },
  { value: "Europe/San_Marino", name: "San Marino" },
  { value: "Africa/Kigali", name: "Kigali" },
  { value: "Europe/Prague", name: "Prague" },
  { value: "Africa/Maseru", name: "Maseru" },
  { value: "Europe/Gibraltar", name: "Gibraltar" },
  { value: "Europe/Zagreb", name: "Zagreb" },
  { value: "Europe/Copenhagen", name: "Copenhagen" },
  { value: "Europe/Monaco", name: "Monaco" },
  { value: "Europe/Belgrade", name: "Belgrade" },
  { value: "Africa/Mbabane", name: "Mbabane" },
  { value: "Europe/Bratislava", name: "Bratislava" },
  { value: "Europe/Vienna", name: "Vienna" },
  { value: "Africa/Tripoli", name: "Tripoli" },
  { value: "Europe/Berlin", name: "Berlin" },
  { value: "Europe/Warsaw", name: "Warsaw" },
  { value: "Europe/Vatican", name: "Vatican" },
  { value: "Europe/Minsk", name: "Minsk" },
  { value: "Europe/Chisinau", name: "Chisinau" },
  { value: "Europe/Moscow", name: "Moscow" },
  { value: "Europe/Zaporozhye", name: "Zaporozhye" },
  { value: "Africa/Nairobi", name: "Nairobi" },
  { value: "Asia/Damascus", name: "Damascus" },
  { value: "Europe/Volgograd", name: "Volgograd" },
  { value: "Europe/Nicosia", name: "Nicosia" },
  { value: "Asia/Nicosia", name: "Nicosia" },
  { value: "Asia/Tel_Aviv", name: "Tel Aviv" },
  { value: "Asia/Kuwait", name: "Kuwait" },
  { value: "Europe/Simferopol", name: "Simferopol" },
  { value: "Europe/Kiev", name: "Kiev" },
  { value: "Africa/Dar_es_Salaam", name: "Dar es Salaam" },
  { value: "Europe/Uzhgorod", name: "Uzhgorod" },
  { value: "Europe/Tallinn", name: "Tallinn" },
  { value: "Africa/Asmara", name: "Asmara" },
  { value: "Antarctica/Syowa", name: "Syowa" },
  { value: "Africa/Kampala", name: "Kampala" },
  { value: "Europe/Tiraspol", name: "Tiraspol" },
  { value: "Asia/Jerusalem", name: "Jerusalem" },
  { value: "Africa/Addis_Ababa", name: "Addis Ababa" },
  { value: "Africa/Asmera", name: "Asmera" },
  { value: "Europe/Athens", name: "Athens" },
  { value: "Asia/Istanbul", name: "Istanbul" },
  { value: "Europe/Istanbul", name: "Istanbul" },
  { value: "Indian/Mayotte", name: "Mayotte" },
  { value: "Asia/Baghdad", name: "Baghdad" },
  { value: "Asia/Bahrain", name: "Bahrain" },
  { value: "Europe/Helsinki", name: "Helsinki" },
  { value: "Asia/Gaza", name: "Gaza" },
  { value: "Asia/Aden", name: "Aden" },
  { value: "Europe/Sofia", name: "Sofia" },
  { value: "Asia/Qatar", name: "Qatar" },
  { value: "Asia/Beirut", name: "Beirut" },
  { value: "Asia/Amman", name: "Amman" },
  { value: "Europe/Bucharest", name: "Bucharest" },
  { value: "Africa/Mogadishu", name: "Mogadishu" },
  { value: "Asia/Riyadh", name: "Riyadh" },
  { value: "Africa/Djibouti", name: "Djibouti" },
  { value: "Indian/Antananarivo", name: "Antananarivo" },
  { value: "Europe/Vilnius", name: "Vilnius" },
  { value: "Europe/Riga", name: "Riga" },
  { value: "Indian/Comoro", name: "Comoro" },
  { value: "Europe/Mariehamn", name: "Mariehamn" },
  { value: "Indian/Reunion", name: "Reunion" },
  { value: "Asia/Yerevan", name: "Yerevan" },
  { value: "Asia/Tbilisi", name: "Tbilisi" },
  { value: "Asia/Dubai", name: "Dubai" },
  { value: "Indian/Mahe", name: "Mahe" },
  { value: "Europe/Samara", name: "Samara" },
  { value: "Asia/Muscat", name: "Muscat" },
  { value: "Asia/Baku", name: "Baku" },
  { value: "Indian/Mauritius", name: "Mauritius" },
  { value: "Asia/Kabul", name: "Kabul" },
  { value: "Asia/Tehran", name: "Tehran" },
  { value: "Asia/Aqtau", name: "Aqtau" },
  { value: "Asia/Ashgabat", name: "Ashgabat" },
  { value: "Asia/Yekaterinburg", name: "Yekaterinburg" },
  { value: "Asia/Tashkent", name: "Tashkent" },
  { value: "Indian/Kerguelen", name: "Kerguelen" },
  { value: "Antarctica/Mawson", name: "Mawson" },
  { value: "Asia/Samarkand", name: "Samarkand" },
  { value: "Asia/Oral", name: "Oral" },
  { value: "Indian/Maldives", name: "Maldives" },
  { value: "Asia/Ashkhabad", name: "Ashkhabad" },
  { value: "Asia/Dushanbe", name: "Dushanbe" },
  { value: "Asia/Aqtobe", name: "Aqtobe" },
  { value: "Asia/Karachi", name: "Karachi" },
  { value: "Asia/Calcutta", name: "Calcutta" },
  { value: "Asia/Colombo", name: "Colombo" },
  { value: "Asia/Kolkata", name: "Kolkata" },
  { value: "Asia/Katmandu", name: "Katmandu" },
  { value: "Asia/Kathmandu", name: "Kathmandu" },
  { value: "Asia/Thimphu", name: "Thimphu" },
  { value: "Asia/Dhaka", name: "Dhaka" },
  { value: "Asia/Qyzylorda", name: "Qyzylorda" },
  { value: "Asia/Thimbu", name: "Thimbu" },
  { value: "Asia/Omsk", name: "Omsk" },
  { value: "Asia/Dacca", name: "Dacca" },
  { value: "Asia/Urumqi", name: "Urumqi" },
  { value: "Indian/Chagos", name: "Chagos" },
  { value: "Asia/Kashgar", name: "Kashgar" },
  { value: "Asia/Bishkek", name: "Bishkek" },
  { value: "Antarctica/Vostok", name: "Vostok" },
  { value: "Asia/Almaty", name: "Almaty" },
  { value: "Asia/Rangoon", name: "Rangoon" },
  { value: "Indian/Cocos", name: "Cocos" },
  { value: "Asia/Ho_Chi_Minh", name: "Ho Chi Minh" },
  { value: "Asia/Phnom_Penh", name: "Phnom Penh" },
  { value: "Asia/Pontianak", name: "Pontianak" },
  { value: "Indian/Christmas", name: "Christmas" },
  { value: "Asia/Novosibirsk", name: "Novosibirsk" },
  { value: "Asia/Novokuznetsk", name: "Novokuznetsk" },
  { value: "Asia/Jakarta", name: "Jakarta" },
  { value: "Asia/Krasnoyarsk", name: "Krasnoyarsk" },
  { value: "Asia/Bangkok", name: "Bangkok" },
  { value: "Antarctica/Davis", name: "Davis" },
  { value: "Asia/Saigon", name: "Saigon" },
  { value: "Asia/Vientiane", name: "Vientiane" },
  { value: "Asia/Hovd", name: "Hovd" },
  { value: "Asia/Ulan_Bator", name: "Ulan Bator" },
  { value: "Asia/Brunei", name: "Brunei" },
  { value: "Asia/Kuching", name: "Kuching" },
  { value: "Asia/Chongqing", name: "Chongqing" },
  { value: "Asia/Choibalsan", name: "Choibalsan" },
  { value: "Asia/Kuala_Lumpur", name: "Kuala Lumpur" },
  { value: "Australia/Perth", name: "Perth" },
  { value: "Asia/Macao", name: "Macao" },
  { value: "Asia/Taipei", name: "Taipei" },
  { value: "Asia/Shanghai", name: "Shanghai" },
  { value: "Antarctica/Casey", name: "Casey" },
  { value: "Asia/Ulaanbaatar", name: "Ulaanbaatar" },
  { value: "Asia/Singapore", name: "Singapore" },
  { value: "Australia/West", name: "West" },
  { value: "Asia/Manila", name: "Manila" },
  { value: "Asia/Irkutsk", name: "Irkutsk" },
  { value: "Asia/Ujung_Pandang", name: "Ujung Pandang" },
  { value: "Asia/Harbin", name: "Harbin" },
  { value: "Asia/Chungking", name: "Chungking" },
  { value: "Asia/Hong_Kong", name: "Hong Kong" },
  { value: "Asia/Macau", name: "Macau" },
  { value: "Asia/Makassar", name: "Makassar" },
  { value: "Australia/Eucla", name: "Eucla" },
  { value: "Asia/Yakutsk", name: "Yakutsk" },
  { value: "Pacific/Palau", name: "Palau" },
  { value: "Asia/Dili", name: "Dili" },
  { value: "Asia/Jayapura", name: "Jayapura" },
  { value: "Asia/Pyongyang", name: "Pyongyang" },
  { value: "Asia/Seoul", name: "Seoul" },
  { value: "Asia/Tokyo", name: "Tokyo" },
  { value: "Australia/Yancowinna", name: "Yancowinna" },
  { value: "Australia/Darwin", name: "Darwin" },
  { value: "Australia/North", name: "North" },
  { value: "Australia/Broken_Hill", name: "Broken Hill" },
  { value: "Australia/South", name: "South" },
  { value: "Australia/Adelaide", name: "Adelaide" },
  { value: "Australia/Canberra", name: "Canberra" },
  { value: "Australia/Queensland", name: "Queensland" },
  { value: "Australia/Hobart", name: "Hobart" },
  { value: "Antarctica/DumontDUrville", name: "DumontDUrville" },
  { value: "Pacific/Saipan", name: "Saipan" },
  { value: "Australia/NSW", name: "NSW" },
  { value: "Australia/Sydney", name: "Sydney" },
  { value: "Australia/Lindeman", name: "Lindeman" },
  { value: "Pacific/Port_Moresby", name: "Port Moresby" },
  { value: "Asia/Vladivostok", name: "Vladivostok" },
  { value: "Australia/ACT", name: "ACT" },
  { value: "Pacific/Guam", name: "Guam" },
  { value: "Australia/Melbourne", name: "Melbourne" },
  { value: "Pacific/Truk", name: "Truk" },
  { value: "Australia/Tasmania", name: "Tasmania" },
  { value: "Australia/Victoria", name: "Victoria" },
  { value: "Australia/Currie", name: "Currie" },
  { value: "Pacific/Yap", name: "Yap" },
  { value: "Australia/Brisbane", name: "Brisbane" },
  { value: "Australia/LHI", name: "LHI" },
  { value: "Australia/Lord_Howe", name: "Lord Howe" },
  { value: "Pacific/Norfolk", name: "Norfolk" },
  { value: "Asia/Sakhalin", name: "Sakhalin" },
  { value: "Pacific/Ponape", name: "Ponape" },
  { value: "Pacific/Noumea", name: "Noumea" },
  { value: "Pacific/Kosrae", name: "Kosrae" },
  { value: "Pacific/Guadalcanal", name: "Guadalcanal" },
  { value: "Asia/Magadan", name: "Magadan" },
  { value: "Antarctica/Macquarie", name: "Macquarie" },
  { value: "Pacific/Efate", name: "Efate" },
  { value: "Antarctica/South_Pole", name: "South Pole" },
  { value: "Pacific/Nauru", name: "Nauru" },
  { value: "Pacific/Wake", name: "Wake" },
  { value: "Pacific/Wallis", name: "Wallis" },
  { value: "Pacific/Tarawa", name: "Tarawa" },
  { value: "Antarctica/McMurdo", name: "McMurdo" },
  { value: "Asia/Anadyr", name: "Anadyr" },
  { value: "Asia/Kamchatka", name: "Kamchatka" },
  { value: "Pacific/Majuro", name: "Majuro" },
  { value: "Pacific/Funafuti", name: "Funafuti" },
  { value: "Pacific/Fiji", name: "Fiji" },
  { value: "Pacific/Auckland", name: "Auckland" },
  { value: "Pacific/Kwajalein", name: "Kwajalein" },
  { value: "Pacific/Chatham", name: "Chatham" },
  { value: "Pacific/Enderbury", name: "Enderbury" },
  { value: "Pacific/Fakaofo", name: "Fakaofo" },
  { value: "Pacific/Apia", name: "Apia" },
  { value: "Pacific/Tongatapu", name: "Tongatapu" },
  { value: "Pacific/Kiritimati", name: "Kiritimati" },
];



// WEBPACK FOOTER //
// ./src/components/TimeZonePicker.tsx